export const VERSION = '2.2.0';
